import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import classNames from 'classnames';

import './style.less';

class LongPressButton extends React.Component {
  static propTypes = {
    clickThreshold: PropTypes.number,
    onClick: PropTypes.func,
    longPressThreshold: PropTypes.number,
    onLongPress: PropTypes.func,
    animationDelay: PropTypes.number,
  };
  /**
   * Note:
   * Click threshold should be longPressThreshold - 1
   * There will be clicks that do not register if click time is between clickThreshold and longPressThreshold
   */

  static defaultProps = {
    // max amount of time that the user can hold onto the button before it isn't considered a click
    clickThreshold: 499,
    onClick: () => {},
    // minimum amount of time before onLongPress is executed
    longPressThreshold: 500,
    onLongPress: () => {},
    // start animating after X milliseconds
    animationDelay: 200,
  };

  state = {
    startTimestamp: null,
    style: {
      ...this.props.style,
      animationDelay: this.props.animationDelay + 'ms',
      animationDuration:
        this.props.longPressThreshold - this.props.animationDelay + 'ms',
    },
  };

  holdTimeout = null;

  componentWillUnmount() {
    this.clear();
  }

  down = e => {
    this.setState({ startTimestamp: Date.now() });
    clearTimeout(this.holdTimeout);
    this.holdTimeout = setTimeout(this.up, this.props.longPressThreshold);
  };

  up = e => {
    this.clear();
    if ((e && !e.target) || !this.state.startTimestamp) {
      return;
    }
    const elapsed = Date.now() - this.state.startTimestamp;
    this.fire(elapsed);
  };

  clear = () => {
    if (this.holdTimeout) {
      clearTimeout(this.holdTimeout);
    }
  };

  fire = elapsed => {
    this.setState({ startTimestamp: null });
    if (elapsed <= this.props.clickThreshold) {
      this.props.onClick();
    } else if (elapsed >= this.props.longPressThreshold) {
      this.props.onLongPress();
    }
  };

  render() {
    const {
      clickThreshold,
      onLongPress,
      longPressThreshold,
      onClick,
      className,
      style,
      animationDelay,
      ...rest
    } = this.props;

    return (
      <Button
        style={this.state.style}
        className={classNames(
          'long-press-button',
          'fill',
          { 'long-press-button--holding': !!this.state.startTimestamp },
          className
        )}
        onMouseLeave={this.clear}
        onMouseDown={this.down}
        onTouchStart={this.down}
        onMouseUp={this.up}
        onTouchCancel={event => {
          event.preventDefault();
          this.up();
        }}
        onTouchEnd={event => {
          event.preventDefault();
          this.up();
        }}
        onContextMenu={event => {
          // prevent the context menu from showing up on long press
          event.preventDefault();
        }}
        {...rest}
      >
        {this.props.children}
      </Button>
    );
  }
}

export { LongPressButton };



// WEBPACK FOOTER //
// ./src/common/Components/LongPressButton/LongPressButton.js